import { h, Component, createRef } from 'preact';
import { getConsent, acceptAll as acceptAllCookies } from '../../preferences';
import Button from '../Button/Button';
import CloseButton from "../Button/CloseButton";
import Settings from '../Settings/Settings';

import { Wrapper, Title, Description, Link } from './styled';

const renderDescription = (description) => {
  const linkRegex = /(.*)<link>(.*)<\/link>(.*)/;
  const match = description.text.match(linkRegex);
  if (!match) {
    return <Description>{description.text}</Description>;
  }

  const link = <Link href={description.link} target="_blank">{match[2]}</Link>;
  return <Description>{match[1]}{link}{match[3]}</Description>;
}

class App extends Component {
  settingsRef = createRef();
  state = {
    opened: !getConsent()
  };

  componentWillMount() {
    this.propOpenedToState(this.props);
  }

  componentDidMount() {
    this.propOpenedToState(this.props);
  }

  propOpenedToState = props => {
    if (props.opened) {
      this.setState({
        opened: props.opened
      });
    }
  };

  render(props) {
    const {
      title,
      position,
      description,
      settings,
      buttons: { acceptAll, acceptSelected },
      style
    } = props.config;

    if (!this.state.opened) {
      return;
    }

    return (
      <Wrapper position={position} style={style}>
        <div>
          {title && <Title>{title}</Title>}
          {description && renderDescription(description)}

          <Settings
            {...settings}
            ref={this.settingsRef}
          />

          <Button
            {...acceptAll}
            primary
            onClick={e => {
              e.preventDefault();
              acceptAllCookies();
              this.setState({ opened: false });
            }}
          />
          <Button
            {...acceptSelected}
            simple
            onClick={e => {
              e.preventDefault();
              this.settingsRef.current.handleSave(e);
              this.setState({ opened: false });
            }}
          />
        </div>
      </Wrapper>
    );
  }
}

export default App;
